export default "__VITE_ASSET__2JZt7BlY__"